import MFilterDialog from './index.vue';

MFilterDialog.install = app => {
  app.component(MFilterDialog.name, MFilterDialog);
};

export default MFilterDialog;
